import axios from "axios";
import { whatsappUrl } from "./whatsapp";

const resolvedBackendUrl = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
export const BACKEND_URL = resolvedBackendUrl;
export const API = `${resolvedBackendUrl}/api`;
export const WHATSAPP_NUMBER = "+918089083404";
export const WHATSAPP_DISPLAY = "WhatsApp Support";
export const INSTAGRAM_URL = "https://www.instagram.com/jltfragrances?igsh=MWJxamRpdHN5ZmFj";
export const SUPPORT_EMAIL = "justlikethatfragrances@gmail.com";

export const waLink = (text = "Hi JLT Fragrances, I'd like a recommendation.") =>
  whatsappUrl(WHATSAPP_NUMBER, text);

const http = axios.create({ baseURL: API });
http.interceptors.request.use((c) => {
  const t = localStorage.getItem("jlt_admin_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
export default http;
